<template>
  <b-button class="regenerate-button" v-b-tooltip.hover :title="title">
    <i class="fa fa-recycle regenerate-icon"></i>
  </b-button>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {};
  },
};
</script>

<style>
.regenerate-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgb(28, 187, 140);
}
.regenerate-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
  width: 45px;
  height: 45px;
}
.regenerate-button:hover .regenerate-icon {
  transform: scale(1.3);
}
.regenerate-button:hover {
  background-color: rgba(28, 187, 140, 0.1);
}
</style>
